import { useState, useEffect } from "react"

interface UseFilterDropdownReturn<TPanel, TFilters> {
  tempFilters: TFilters
  setTempFilters: React.Dispatch<React.SetStateAction<TFilters>>
  openTagDropdown: (panel: TPanel) => void
  closeTagDropdown: () => void
  isTagDropdownOpen: (panel: TPanel) => boolean
}

export function useFilterDropdown<TPanel, TFilters>(filters: TFilters): UseFilterDropdownReturn<TPanel, TFilters> {
  const [activeTagPanel, setActiveTagPanel] = useState<TPanel | null>(null)
  const [tempFilters, setTempFilters] = useState<TFilters>(filters)

  // Sync tempFilters when filters change externally
  useEffect(() => {
    setTempFilters(filters)
  }, [filters])

  const openTagDropdown = (panel: TPanel) => {
    if (activeTagPanel !== panel) {
      setTempFilters(filters)
    }
    setActiveTagPanel(activeTagPanel === panel ? null : panel)
  }

  const closeTagDropdown = () => {
    setActiveTagPanel(null)
  }

  const isTagDropdownOpen = (panel: TPanel) => activeTagPanel === panel

  return {
    tempFilters,
    setTempFilters,
    openTagDropdown,
    closeTagDropdown,
    isTagDropdownOpen,
  }
}
